import { Report } from './generatedReportsTypes';

export const getReportCellValueUtil = (
  report?: Report | null,
  columnHeaderId?: string,
  entityType?: string,
  entityId?: string,
): string | undefined => {
  if (!report) {
    return undefined;
  }
  const column = report.columns.find(
    (column) => 'id' in column.headerValue && column.headerValue.id === columnHeaderId,
  );
  if (!column?.id) {
    return undefined;
  }
  const row = report.rows.find((row) => row.entityType === entityType && row.entityId === entityId);
  if (!row?.cellData) {
    return undefined;
  }
  const cell = row.cellData.find((cell) => cell.columnId === column.id);
  if (!cell) {
    return undefined;
  }
  return cell.value;
};

export const getReportCellNumberValueUtil = (
  report?: Report | null,
  columnHeaderId?: string,
  entityType?: string,
  entityId?: string,
): number | undefined => {
  const valueString = getReportCellValueUtil(report, columnHeaderId, entityType, entityId);
  const value = Number(valueString);
  return isNaN(value) ? undefined : value;
};
